import { useCallback } from 'react';
import { history } from '../Routing';

export default function useNavigateTo(target: string): () => void {
    return useCallback(() => {
        history.push(target, { "ref": history.location.pathname })
        history.go(0)
    }, [target])
}
